// Mutation to send a single sms to a single tenant
export const SendSmsMutation = (propertyIds, tenantIds, message) => {
    const mutation = `
    mutation{
      sendSms(propertyIds:${JSON.stringify(propertyIds)},tenantIds:${JSON.stringify(tenantIds)},message:${JSON.stringify(message)}){
          success
          message
        }
      }
    `
    return mutation;
  }

export const ResendSmsMutation = (messageIds) => {
  const mutation = `
  mutation{
    resendSms(messageIds: ${JSON.stringify(messageIds)}){
      success
      message
    }
  }
  `
  return mutation;
}


export const SendInvoiceSmsMutation = (invoiceIds, sendDate = "") => {
  const mutation = `
  mutation{
    sendInvoiceSms(invoiceIds:${JSON.stringify(invoiceIds)}, sendDate:${JSON.stringify(sendDate)}){
      success
      message
      invoices{
        id
        message{
          id
        }
      }
    }
  }
  `
  return mutation;
}

export const SendTenantStatementSmsMutation = (tenantIds) => {
  const mutation = `
  mutation{
    sendTenantStatementSms(tenantIds:${JSON.stringify(tenantIds)}){
      messages{
          id
          delivered
          message
      }
      message
      success
      errors
    }
  }
  `
  return mutation;
}

export const SendPaymentReceiptSmsMutation = (paymentIds) => {
  const mutation = `
    mutation{
      sendPaymentReceipts(paymentIds: ${JSON.stringify(paymentIds)} ){
        success
        message
        payments{
          id
          message{
            id
          }
        }
      }
    }
  `;
  return mutation;
}

export const SendPaymentReminderSmsMutation = (tenantIds) => {
  const mutation = `
  mutation{
    sendPaymentReminder(tenantIds:${JSON.stringify(tenantIds)}){
      success
      message
      successfulMessages{
        id
        message
      }
      unsuccessfulMessages{
        id
        message
      }
    }
  }
  `
  return mutation
}

export const SendBulkPaymentReminderSmsMutation = (propertyIds) => {
  const mutation = `
  mutation{
    sendBulkPaymentReminders(propertyIds:${JSON.stringify(propertyIds)}){
      success
      message
    }
  }
  `
  return mutation
}
